// A single module-level formatter: `Intl.DateTimeFormat` construction is costly, and the instance is
// stateless and reusable across every call.
const dateFormatter = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long' });

const formatLongDate = (isoDate: string): string => dateFormatter.format(new Date(isoDate));

export default formatLongDate;
